import { useGlobalStyles } from '~shared/styles/globalStyles'
import { useTranslation } from 'react-i18next'
import Col from '~shared/components/MuiGrid/Col'
import { Box, Divider, ImageList, ImageListItem, Typography } from '@mui/material'
import Row from '~shared/components/MuiGrid/Row'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getSpareAxleRequestFormData } from '~store/wizardSpareAxleRequest/selectors'
import { useAxleComponentOptions, useSalutationOptions } from '~api/models'
import { AxleComponentType } from '@saf/saf-kundenportal-frontend-api/models/AxleComponentType'
import imgAxleBody from '~assets/axleComponents/axleBody.png'
import imgCompleteAxle from '~assets/axleComponents/completeAxle.png'
import imgCompleteAggregate from '~assets/axleComponents/completeAggregate.png'

const Step3Summary: React.FC = () => {
  const gs = useGlobalStyles()
  const { t } = useTranslation()
  const data = useSelector(getSpareAxleRequestFormData)
  const salutationOptions = useSalutationOptions()
  const axleComponentOptions = useAxleComponentOptions()
  const images = [
    {
      img: imgAxleBody,
      title: AxleComponentType.AXLEBODY,
    },
    {
      img: imgCompleteAxle,
      title: AxleComponentType.COMPLETEAXLE,
    },
    {
      img: imgCompleteAggregate,
      title: AxleComponentType.COMPLETEAGGREGATE,
    },
  ]
  const imageList = useMemo(() => {
    return (
      <ImageList sx={{ width: 'auto', height: 'auto' }} cols={images.length}>
        {images.map((item) => (
        data.step2?.axleComponent.map((comp) => {
          if (comp === item.title) {
            return (
              <ImageListItem key={item.img}>
                <img
                  src={item.img}
                  srcSet={item.img}
                  alt={item.title}
                  loading='lazy'
                />
              </ImageListItem>
            )
          }
        })
        ))}
      </ImageList>
    )
  }, [data.step2, images])

  return <>
    <Row className={gs.gridTopMarginFix}>
      <Col xs={12}>
        <Box fontStyle='italic'>
          <Typography variant='h4' component='h2'>
            {t('common:headSpareAxleRequest')}
          </Typography>
          <Divider className={gs.marginBottomTiny} variant='fullWidth' style={{ maxWidth: '125px', backgroundColor: '#000' }} />
          <Typography variant='h5' component='h4' className={gs.marginBottomTiny} color='secondary'>
            {t('common:step3Summary')}
          </Typography>
        </Box>
      </Col>
    </Row>
    <Row>
      <Col xs={4}>
        <Typography color='secondary' fontSize='small'>
          {t('common:contactDetails')}
        </Typography>
      </Col>
      <Col xs={4}>
        <Typography color='secondary' fontSize='small'>
          {t('common:axleDetails')}
        </Typography>
      </Col>
      <Col xs={4} />
    </Row>
    <Row>
      <Col xs={4}>
        <Typography variant='body1'>
          {data.step1?.company}
        </Typography>
        <Typography variant='body1'>
          {data.step1?.streetAndNumber}
        </Typography>
        <Typography variant='body1'>
          {`${data.step1?.zip} ${data.step1?.city}`}
        </Typography>
        <br />
        <Typography variant='body1'>
          {salutationOptions.find((salutation) => {
            return salutation.value === data.step1?.salutation
          })?.label}
        </Typography>
        <Typography variant='body1'>
          {`${data.step1?.firstname} ${data.step1?.lastname}`}
        </Typography>
        <Typography variant='body1'>
          {data.step1?.email}
        </Typography>
        <Typography variant='body1'>
          {data.step1?.phone}
        </Typography>
      </Col>
      <Col xs={4}>
        <Typography>
          {`${t('common:serialNumber')}:`}
        </Typography>
        <Typography variant='body1'>
          {data.step2?.serialNumber}
        </Typography>
        <br />
        <Typography>
          {`${t('common:component')}:`}
        </Typography>
        <Typography variant='body1'>
          {data.step2?.axleComponent.map((comp:AxleComponentType) => {
            return (axleComponentOptions.map((compOp) => {
              if (compOp.value === comp) return <Typography key={compOp.value}>{compOp.label} <br /></Typography>
            }))
          })}
        </Typography>
        <br />
        <Typography>
          {`${t('common:optionalInfo')}:`}
        </Typography>
        <Typography variant='body1'>
          {data.step2?.optionalInfo}
        </Typography>
      </Col>
    </Row>
    <Row>
      {imageList}
    </Row>
  </>
}

export default Step3Summary
